"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// import './MultiselectDropdown.css';
require("@csod/assets/assets/normalize.css");
require("player-theming/theme.css");
require("@csod/assets/assets/csod-icons.css");
require("@csod/assets/assets/csod-style-utilities.css");
var player_react_portal_1 = require("player-react-portal");
var react_hotkeys_1 = require("react-hotkeys");
var utils_1 = require("player-core/utils");
var MultiselectDropdownContent_1 = require("./MultiselectDropdownContent");
var portal_position_1 = require("player-react-portal/build/portal-position");
var MultiselectDropdown = (function (_super) {
    __extends(MultiselectDropdown, _super);
    function MultiselectDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownIsOpen: false,
            dropdownPosition: {
                top: null,
                left: null
            },
            selectedTotal: (_this.props.items || []).filter(function (x) { return x.isChecked; }).length,
            calculatedWidth: 'Auto',
            focusedItem: -1,
            items: _this.props.items || [],
        };
        _this._updateLabel = function (items) {
            var selectedTotal = _this.state.selectedTotal;
            if (selectedTotal !== items.length) {
                _this.setState({ selectedTotal: items.length });
            }
        };
        _this._clickHandler = function (e) {
            var target = e.target;
            if (_this.refButton &&
                !_this.refButton.contains(target) &&
                (!_this.refDropdown || !_this.refDropdown._listElem.contains(target))) {
                _this._closeDropdown();
            }
        };
        _this._onClick = function () {
            var dropdownIsOpen = _this.state.dropdownIsOpen;
            var calculatedWidth = _this.refButton ? _this.refButton.getBoundingClientRect().width : 'Auto';
            _this.setState({
                dropdownIsOpen: !dropdownIsOpen,
                focusedItem: -1,
                calculatedWidth: calculatedWidth
            });
        };
        _this._onChange = function (items) {
            _this._updateLabel(items);
            if (_this.props.onChange) {
                _this.props.onChange(items);
            }
        };
        _this._keyMap = function () { return ({
            keyEsc: ['tab', 'shift+tab', 'esc'],
            keySpace: 'space',
            keyUp: 'up',
            keyDown: 'down'
        }); };
        _this._closeDropdown = function () {
            _this.setState({
                dropdownPosition: {
                    top: null,
                    left: null
                },
                dropdownIsOpen: false,
                focusedItem: -1
            }, function () { return _this.refButton.focus(); });
        };
        /* istanbul ignore next */
        _this._keySpace = function (e) {
            var _a = _this.state, focusedItem = _a.focusedItem, items = _a.items;
            items[focusedItem].isChecked = !items[focusedItem].isChecked;
            _this.setState({ items: items });
            _this._onChange(items.filter(function (x) { return x.isChecked; }));
            e.preventDefault();
        };
        /* istanbul ignore next */
        _this._keyUp = function (e) {
            var _a = _this.state, dropdownIsOpen = _a.dropdownIsOpen, focusedItem = _a.focusedItem;
            var _b = _this.props.items, items = _b === void 0 ? [] : _b;
            var previousItem = focusedItem - 1;
            if (dropdownIsOpen && items.length && focusedItem > -1 && previousItem > -1) {
                _this._setFocusItem(previousItem);
            }
            e.preventDefault();
        };
        /* istanbul ignore next */
        _this._keyDown = function (e) {
            var _a = _this.state, dropdownIsOpen = _a.dropdownIsOpen, focusedItem = _a.focusedItem;
            var _b = _this.props.items, items = _b === void 0 ? [] : _b;
            var nextItem = focusedItem + 1;
            if (dropdownIsOpen && items.length && focusedItem < items.length - 1) {
                _this._setFocusItem(nextItem);
            }
            e.preventDefault();
        };
        _this._setDropdownPosition = function () {
            var dropdownPosition = portal_position_1.positionDropdown(_this.refDropdown && _this.refDropdown._listElem, _this.refButton && _this.refButton, document.body);
            _this.setState({ dropdownPosition: dropdownPosition });
        };
        _this._setFocusItem = function (focusedItem) {
            var items = _this.state.items;
            var el = document.getElementById(items[focusedItem].value + "--" + focusedItem);
            if (el) {
                el.focus();
            }
            _this.setState({ focusedItem: focusedItem });
        };
        _this._onCheckboxClick = function (e, i) {
            var items = _this.state.items;
            items[i].isChecked = !items[i].isChecked;
            _this.setState({ items: items });
            _this._onChange(items.filter(function (x) { return x.isChecked; }));
            e.preventDefault();
        };
        return _this;
    }
    MultiselectDropdown.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ items: nextProps.items });
        this._updateLabel((nextProps.items || []).filter(function (x) { return x.isChecked; }));
    };
    MultiselectDropdown.prototype.render = function () {
        var _this = this;
        var _a = this.state, items = _a.items, selectedTotal = _a.selectedTotal, calculatedWidth = _a.calculatedWidth, focusedItem = _a.focusedItem;
        var _b = this.props, isEnabled = _b.isEnabled, buttonTextSuffix = _b.buttonTextSuffix, placeholder = _b.placeholder, dropdownHeight = _b.dropdownHeight;
        var cssOuter = ['p-multiselectdropdown'];
        if (!isEnabled) {
            cssOuter.push('is-disabled');
        }
        var handlers = {
            keyEsc: this._closeDropdown,
            keySpace: this._keySpace,
            keyUp: this._keyUp,
            keyDown: this._keyDown
        };
        var cssButton = ['dropdown-button', 'p-f-w-6', 'p-bg-hv-grey70', 'p-bc-f-primary50', 'p-ph-grey50'];
        var cssButtonText = ['dropdown-button-text'];
        var buttonText = selectedTotal + " " + (buttonTextSuffix && buttonTextSuffix.trim());
        if (!selectedTotal && placeholder) {
            cssButtonText.push('placeholder');
            buttonText = placeholder;
        }
        return (React.createElement("div", { className: cssOuter.join(' '), "data-tag": this.props.tag },
            React.createElement(react_hotkeys_1.HotKeys, { keyMap: this._keyMap(), handlers: handlers, focused: true },
                React.createElement("button", { ref: function (r) {
                        _this.refButton = r;
                    }, id: this.props.id, onClick: this._onClick, className: cssButton.join(' '), disabled: !isEnabled, type: "button" },
                    React.createElement("span", { className: cssButtonText.join(' ') }, buttonText),
                    React.createElement("span", { className: "p-icon-down-triangle" })),
                React.createElement(player_react_portal_1.Portal, { isOpened: this.state.dropdownIsOpen, onOpen: this._setDropdownPosition, closeOnOutsideClick: !this.state.dropdownIsOpen, onClose: this._closeDropdown },
                    React.createElement(react_hotkeys_1.HotKeys, { keyMap: this._keyMap(), handlers: handlers, focused: true },
                        React.createElement(MultiselectDropdownContent_1.default, { ref: function (r) {
                                _this.refDropdown = r;
                            }, id: this.props.id + "_dropdown", width: calculatedWidth, items: items, focusedItem: focusedItem, coordinates: this.state.dropdownPosition, onCheckboxClick: this._onCheckboxClick, setFocusItem: this._setFocusItem, maxHeight: dropdownHeight }))))));
    };
    return MultiselectDropdown;
}(React.Component));
MultiselectDropdown.defaultProps = {
    id: 'msd-' + utils_1.createUUID(),
    tag: '',
    placeholder: '',
    buttonTextSuffix: '',
    isEnabled: true,
    dropdownHeight: null
};
exports.MultiselectDropdown = MultiselectDropdown;
exports.default = MultiselectDropdown;
//# sourceMappingURL=MultiselectDropdown.js.map


//////////////////
// WEBPACK FOOTER
// ../player-search-module/build/control/MultiselectDropdown/MultiselectDropdown.js
// module id = 688
// module chunks = 0